/**
 * 首页
 */
import React, { Component } from "react";
import HeaderView from '../header/index';
import FooterView from '../footer/index';
import lang from '../lang/index';
import Modal from 'boron/ScaleModal';


const noop = function(){};

const style = {
    modalStyle: {
        width: '500px'
    },
    contentStyle: {
        width: '500px',
        borderRadius: '6px',
        backgroundColor: '#fff',
        outline: 0
    },
    backdropStyle: {
        backgroundColor: "rgba(0,0,0, 0.5)"
    }
}

class News extends Component {
    constructor(props) {
        super(props);
        this.state = {
            list: []
        };
    }
    componentWillMount(){
        
    }

    handleClick=(e)=>{
        let userInfo = UP.Global.getUser();
        let origin;
        let params;
        let url;

        if (location.host == 'h5.upliveapp.com') {
            origin = 'http://h5.upliveapp.com';
        } else {
            origin = 'http://m.upliveapps.com';
        }

        params = {
            uid: userInfo.uid,
            country: userInfo.countryCode,
            language: UP.Global.siteLanguage,
            level: userInfo.grade
        }
        
        url = origin + '/upservice/custom.html?' + $.param(params); 

        location.href = url;
    }

    buy=()=>{
        this.refs.pop.show();
    }

    onClose(){
        this.refs.pop.hide();
    }

    render() {
        return (
        	<div className="news">
        		<HeaderView selected="news"/>
        		<div className="news-wrapper">
                    <h2>{lang.template('收费资讯')}</h2>
        			<div className="news-container">
                        <ul>
                            <li>
                                <h3>云智联高端艺人化妆技巧</h3>
                                <em>¥50</em>
                                <button onClick={this.buy}>付费浏览</button>
                            </li>
                            <li>
                                <h3>云智联高端艺人唱歌技巧</h3>
                                <em>¥50</em>
                                <button onClick={this.buy}>付费浏览</button>
                            </li>
                            <li>
                                <h3>云智联高端艺人表演技巧</h3>
                                <em>¥50</em>
                                <button onClick={this.buy}>付费浏览</button>
                            </li>
                            <li>
                                <h3>云智联艺人穿衣技巧</h3>
                                <em>¥50</em>
                                <button onClick={this.buy}>付费浏览</button>
                            </li>
                            <li>
                                <h3>云智联艺人聊天技巧</h3>
                               <em>¥50</em>
                                <button onClick={this.buy}>付费浏览</button>
                            </li>
                            <li>
                                <h3>云智联男神／女神心理养成技巧</h3>
                               <em>¥50</em>
                                <button onClick={this.buy}>付费浏览</button>
                            </li>
                            <li>
                                <h3>云智联男神／女神气质养成技巧</h3>
                                <em>¥50</em>
                                <button onClick={this.buy}>付费浏览</button>
                            </li>
                            <li>
                                <h3>云智联艺人肢体语言</h3>
                                <em>¥50</em>
                                <button onClick={this.buy}>付费浏览</button>
                            </li>
                        </ul>
                    </div>
                   <Modal 
                        ref="pop"  
                        closeOnClick={false}              
                        modalStyle={style.modalStyle}  
                        backdropStyle={style.backdropStyle} 
                        contentStyle={style.contentStyle}
                    >

                        <div className="bind-pop">
                            <div className="box">
                                <div className="bind-pop-hd">
                                    <span className="close" onClick={()=>this.onClose()}>x</span>
                                </div>
                                <div className="wechat-bind clearfix">
                                    <img src={require('../../images/common/zhifubao.jpg')}/>
                                    <p className="desc">选择希望购买的产品，并在付款后通过app内的官方客服进行联系，也可通过<em>upcs@asiainnovations.com</em>以邮件的方式进行联系，官方工作人员在确定收款后，会进行发货。</p>
                                </div>
                            </div>
                        </div>
                    </Modal>
                    <div className="content-tip" onClick={this.handleClick}>
                        {lang.template('付款遇到问题？点击联系客服')}
                    </div>
        		</div>
        	</div>
        )
    }
}

export default News;


// WEBPACK FOOTER //
// ./js/views/news.js